'use strict';

var $ = require('jquery'),
    inputfields = require('../utils/inputfields'),
    validator = require('../utils/validator'),
    uniform = require('./uniform'),
    Dialog = require('../lib/dialog').default,
    util = require('../utils/util'),
    progress = require('../utils/progress');

var onsitereturns = {
    returnInformations: {},

    init: function () {
        validator.init();

        function collectSelectedItems() {
            var selectedItems = [];
            $('.onsitereturn.chooseItem:checkbox:checked').each(function () {
                var container = $(this).closest('.row-product');

                var selectedItem = container.find('select').val();
                var primeLineNo = container.find('input[name="primeLineNo"]');

                if (primeLineNo && primeLineNo.length) {
                    selectedItem += '_' + primeLineNo.val();
                }
                const returnReason = container.find('.item-return-reason-select .return-reason');
                if (returnReason && returnReason.val()) {
                    selectedItem += '_' + returnReason.val();
                }
                selectedItems.push(selectedItem);
            });
            $('#selectedItems').val(JSON.stringify(selectedItems));
            $('#selectedItems2').val(JSON.stringify(selectedItems));
        }

        function makeReasonFieldMandatory(returnReason) {
            if (returnReason.hasClass('required')) {
                returnReason.removeClass('required');
                const reasonFormField = returnReason.closest('.form-row-select');
                if (reasonFormField.hasClass('validation-error')) {
                    reasonFormField.removeClass('validation-error');
                    reasonFormField.find('.error-msg').remove();
                }
            } else {
                returnReason.addClass('required');
            }
        }

        function showReasonDetail(id) {
            var idParts = id.split('_');

            $('.reason-choose_' + idParts[1]).hide();
            $('#submitReturnform').attr('disabled', 'disabled');

            if (idParts[0]) {
                $('#' + id).show();
            }
        }

        function updateReturnInformations() {
            $('.row-product').each(function () {
                var $this = $(this);
                var lineItemReturn = $this.find('.lineItemReturn').val();

                if (!lineItemReturn) {
                    return;
                }

                var quantity = lineItemReturn.split('_')[0];
                var prodID = lineItemReturn.split('_')[1];

                onsitereturns.returnInformations[prodID] = {};
                onsitereturns.returnInformations[prodID].quantity = quantity;
                onsitereturns.returnInformations[prodID].reason = $this
                    .find('.reason_select')
                    .find('option:selected')
                    .text();
                onsitereturns.returnInformations[prodID].subReason = $this
                    .find('.subreason')
                    .find('input.active')
                    .val();
                onsitereturns.returnInformations[prodID].text = $this.find('.reasonText').val();
            });

            $('#returnInformations').val(JSON.stringify(onsitereturns.returnInformations));
        }

        function fillReturnInformationsForm() {
            var oldReturnInformations = JSON.parse(JSON.stringify(onsitereturns.returnInformations));

            $.each(oldReturnInformations, function (prodID, returnInformations) {
                var $productRow = $(
                    '.lineItemReturn[value="' + returnInformations.quantity + '_' + prodID + '"]'
                ).parent('.row-product');
                var $resonSelect = $productRow.find('.reason_select');
                var resonSelectVal = $resonSelect.find(':contains("' + returnInformations.reason + '")').val();
                var subReasonId = $productRow
                    .find('#' + resonSelectVal + ' label:contains("' + returnInformations.subReason + '")')
                    .attr('for');
                var $subReasonOption = $productRow.find('#' + subReasonId);
                var $reasonText = $productRow.find('.reasonText');

                $resonSelect.val(resonSelectVal);
                showReasonDetail(resonSelectVal);
                $subReasonOption.prop('checked', true);
                $subReasonOption.addClass('active');
                $reasonText.val(returnInformations.text);
            });

            $('#submitReturnform').prop('disabled', false);
            $.uniform.update();
            onsitereturns.returnInformations = oldReturnInformations;
            $('#returnInformations').val(JSON.stringify(onsitereturns.returnInformations));
        }

        function guestStartFormSubmit() {
            var $guestForm = $('.onsitereturns-guest-start');

            if ($guestForm.length) {
                if (
                    $guestForm.find('input').filter(function () {
                        return this.value === '';
                    }).length == 0
                ) {
                    $('#submitReturnform').removeAttr('disabled');
                } else {
                    $('#submitReturnform').attr('disabled', 'disabled');
                }
            }
        }

        function labelPrintFormSubmit() {
            var $generateForm = $('#generateLabel');

            if ($generateForm.length) {
                $generateForm.submit();
            }
        }

        guestStartFormSubmit();

        /**
         * Create the return calendar for the available return days selection - BSDDEV-10342
         * Blocked dates for each country "custom object: ReturnPickUpBlockDates"
         * @function onReturnCalendarJS
         */
        function onReturnCalendarJS() {
            // Current date, year and month
            const date = new Date();
            const currentYear = date.getFullYear();

            // Range for return days
            const ReturnDaysRange = parseInt($('#blocked_range_dates').attr('return-days-range'));

            // The available start date for return
            let availableStartDate = new Date();
            availableStartDate.setDate(availableStartDate.getDate() + 2);
            availableStartDate.setHours(0, 0, 0, 0);

            // The days when delivery is blocked
            let blockedDays = [];
            let $blockedDaysEl = $('#blocked_range_dates').attr('data-blocked-days');
            try {
                blockedDays = $blockedDaysEl ? JSON.parse($blockedDaysEl) : [];
            } catch (error) {}

            // The available end date for return
            let availableEndDate = new Date();
            availableEndDate.setDate(availableEndDate.getDate() + 1);
            var count = 0;

            while (count < ReturnDaysRange) {
                availableEndDate.setDate(availableEndDate.getDate() + 1);
                // Format the date string to "YYYY-MM-DD"
                let availableEndDateString =
                    availableEndDate.getFullYear() +
                    '-' +
                    ('0' + (availableEndDate.getMonth() + 1)).slice(-2) +
                    '-' +
                    ('0' + availableEndDate.getDate()).slice(-2);

                // Check if the current day is not a block day
                if (blockedDays && !blockedDays.includes(availableEndDateString)) {
                    count++;
                }
            }

            availableEndDate.setDate(availableEndDate.getDate());
            availableEndDate.setHours(0, 0, 0, 0);

            /**
             * This loop populates the year dropdown.
             */
            for (let i = currentYear; i <= availableEndDate.getFullYear(); i++) {
                $('#calendarYear').append(
                    $('<option>', {
                        value: i,
                        text: i
                    })
                );
            }

            // Hide months outside the available return date range
            var DropdownMonths = $('#calendarMonth');
            DropdownMonths.find('option').each(function () {
                var monthIndex = parseInt($(this).val());
                if (monthIndex < availableStartDate.getMonth() || monthIndex > availableEndDate.getMonth()) {
                    $(this).hide();
                }
            });

            // Set the current year and month dropdowns as per available dates
            $('#calendarYear').val(availableStartDate.getFullYear());
            $('#calendarMonth').val(availableStartDate.getMonth());

            /**
             * This function updates the calendar grid based on the given month and year.
             * @param {number} month - The selected month.
             * @param {number} year - The selected year.
             */
            function updateCalendar(month, year) {
                $('#calendarDays').empty();

                // Adding the days of the week at the top
                let weekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
                weekdays.forEach(day => {
                    $('#calendarDays').append('<div class="day-name">' + day + '</div>');
                });

                // Get the number of days in the selected month and year
                let daysInMonth = new Date(year, month + 1, 0).getDate();

                // Find out the day of the week for the first day of this month
                let firstDayOfMonth = new Date(year, month, 1).getDay();

                // Create empty slots for days of the previous month
                for (let i = 0; i < firstDayOfMonth; i++) {
                    $('#calendarDays').append('<div class="return-day blocked-day"></div>');
                }

                // Generate the days for the selected month and year
                for (let i = 1; i <= daysInMonth; i++) {
                    let newDate = new Date(year, month, i);

                    // Format the date string to "YYYY-MM-DD"
                    let newDateString =
                        newDate.getFullYear() +
                        '-' +
                        ('0' + (newDate.getMonth() + 1)).slice(-2) +
                        '-' +
                        ('0' + newDate.getDate()).slice(-2);

                    if (newDate >= availableStartDate && newDate <= availableEndDate) {
                        if (blockedDays && !blockedDays.includes(newDateString)) {
                            $('#calendarDays').append('<div class="return-day">' + i + '</div>');
                        } else {
                            $('#calendarDays').append('<div class="return-day disabled">' + i + '</div>');
                        }
                    } else {
                        $('#calendarDays').append('<div class="return-day blocked-day"></div>');
                    }
                }
            }

            // Update the calendar for the current month and year
            updateCalendar(availableStartDate.getMonth(), availableStartDate.getFullYear());

            // Update the calendar when a new month or year is selected
            $('#calendarYear, #calendarMonth').change(function () {
                updateCalendar(parseInt($('#calendarMonth').val()), parseInt($('#calendarYear').val()));
            });

            /**
             * Selects the clicked day if it's not disabled.
             */
            $('#calendarDays').on('click', '.return-day', function () {
                if (!$(this).hasClass('disabled')) {
                    $('.return-day').removeClass('selected');
                    $(this).addClass('selected');

                    // Get the selected date
                    let selectedDate = new Date($('#calendarYear').val(), $('#calendarMonth').val(), $(this).text());

                    // Format the selected date
                    let formattedDate =
                        selectedDate.getFullYear() +
                        '-' +
                        ('0' + (selectedDate.getMonth() + 1)).slice(-2) +
                        '-' +
                        ('0' + selectedDate.getDate()).slice(-2);
                    console.log('Selected date: ' + formattedDate);
                    $('#pickup_date').val(formattedDate);
                    $('#submitReturnform').prop('disabled', false);
                }
            });
        }

        $('#SFEMail').on('change keyup blur', function () {
            var $generateForm = $('#generateLabel');
            var $button = $('button[type="submit"]');

            validator.initForm($generateForm);
            $button.prop('disabled', !$generateForm.valid());
        });

        /**
         * @function
         * @description submit and renders response
         **/
        $('#returnForm').on('submit', function (e) {
            var $this = $(this);

            e.preventDefault();
            validator.initForm($this);

            if ($this.valid()) {
                var $returnFormInclude = $(this).closest('.customerservice-content-confined, #primary');

                progress.show($this);

                if ($(this).hasClass('generateReturnLabel')) {
                    onsitereturns.returnInformations = {};
                    onsitereturns.mailTo = $('.mail-to').val();
                    $this.find('#mailTo').val(onsitereturns.mailTo);
                    var data = $this.serialize();

                    $.ajax({
                        type: 'POST',
                        url: $(this).attr('action'),
                        data: data
                    }).done(function (response) {
                        $returnFormInclude.html(response);
                        inputfields.init();
                        validator.init();
                        onsitereturns.init();
                        uniform();
                        $('html body').scrollTop(0);
                        $(window).scrollTop(0);
                        progress.hide($this);
                        labelPrintFormSubmit();
                    });
                } else {
                    var data = $this.serialize();
                    $.ajax({
                        type: 'POST',
                        url: $(this).attr('action'),
                        data: data
                    }).done(function (response) {
                        $returnFormInclude.html(response);
                        inputfields.init();
                        validator.init();
                        onsitereturns.init();
                        uniform();
                        $('html body').scrollTop(0);
                        $(window).scrollTop(0);
                        progress.hide($this);
                    });
                }
            }

            return false;
        });

        /**
         * @function
         * @description submit and renders response
         **/
        $('#confirmForm').on('submit', function (e) {
            var $this = $(this);

            e.preventDefault();
            validator.initForm($this);

            if ($this.valid()) {
                var $returnFormInclude = $(this).closest('.customerservice-content-confined');

                progress.show($this);

                onsitereturns.returnInformations = {};
                onsitereturns.mailTo = $('.mail-to').val();

                var data = $this.serialize();
                $.ajax({
                    type: 'POST',
                    url: $(this).attr('action'),
                    data: data
                }).done(function (response) {
                    $returnFormInclude.html(response);
                    inputfields.init();
                    validator.init();
                    onsitereturns.init();
                    uniform();
                    $('html body').scrollTop(0);
                    $(window).scrollTop(0);
                    progress.hide($this);
                });
            }

            return false;
        });

        $('#generateLabel').on('submit', function (e) {
            var $this = $(this);
            var $returnFormInclude = $(this).closest('.customerservice-content-confined');
            $this.find('#mailTo').val(onsitereturns.mailTo);
            $this.find('#SFEMail').val(onsitereturns.mailTo);
        });

        $('#orderNumberInfo').on('click keypress', function (event) {
            if (util.isClickOrSpaceOrEnter(event)) {
                const dialog = new Dialog({
                    html: $('#orderNumberInfoContent').html(),
                    additionalClasses: ['order-number-info-overlay'],
                    useLegacyBackdrop: true,
                    isModal: false,
                    useLegacyContainer: true,
                    canCloseOnBackdropClick: true,
                    hasTitleBar: true,
                    hasCloseText: false,
                    callback: () => {
                        $('.ui-dialog-content').removeAttr('style');
                        $('.ui-dialog').css('top', '100px');
                        $('body').addClass('ui-dialog-position-fixed');
                        document.activeElement.blur();

                        $('.order-number-info-overlay .close, .ui-widget-overlay').on('click', function () {
                            dialog.close();
                        });

                        $('.order-number-info-overlay .icon-close, .order-number-info-overlay .button-trans.close').on(
                            'keypress',
                            function (e) {
                                if (util.isClickOrSpaceOrEnter(e)) {
                                    dialog.close();
                                }
                            }
                        );

                        $('.order-number-info-overlay').focus();
                    },
                    closeCallback: () => {
                        $('body').removeClass('ui-dialog-position-fixed');
                        document.activeElement.blur();
                        $('.ui-widget-overlay.ui-front').remove();
                    }
                });
                dialog.open();
            }
        });

        $('.onsitereturn.chooseItem').on('click', function () {
            var checkBoxesChecked = $('.onsitereturn.chooseItem:checkbox:checked').length;
            if (checkBoxesChecked > 0) {
                $('#submitReturnform').removeAttr('disabled');
            } else {
                $('#submitReturnform').attr('disabled', 'disabled');
            }
        });

        $('.onsitereturn.chooseItem').on('click', function () {
            let container = $(this).closest('.row-product');
            let returnReason = container.find('.item-return-reason-select .return-reason');
            if (returnReason) {
                makeReasonFieldMandatory(returnReason);
            }

            collectSelectedItems();
        });

        $('[name="quantitySelection"]').on('change', collectSelectedItems);

        $('.reason_select').change(function () {
            $(this).closest('.item-quantity-select').find('input[type="radio"]').prop('checked', false);
            $.uniform.update();
            showReasonDetail(this.value);
        });

        $('input:radio').on('click', function () {
            var disabled = false;
            $(this).closest('.row-product').find('input:radio').removeClass('active');
            $(this).addClass('active');
            $('.row-product').each(function () {
                if ($(this).find('.subreason').find('input.active').val() === 'undefined') {
                    disabled = true;
                }
            });
            updateReturnInformations();
            if (!disabled) {
                $('#submitReturnform').removeAttr('disabled');
            }
        });

        $('.reasonText').on('keyup', function () {
            updateReturnInformations();
        });

        $('.return-reason').on('change', function () {
            $(this).attr('selected', 'selected');
            collectSelectedItems();
        });

        $('a#backToEditReason').on('click keypress', function (event) {
            if (util.isClickOrSpaceOrEnter(event)) {
                var $this = $(this);
                var data = $('#editReason').serialize(),
                    $returnFormInclude = $this.closest('.customerservice-content-confined');

                progress.show($this);

                $.ajax({
                    type: 'POST',
                    url: $('#editReason').attr('action'),
                    data: data
                }).done(function (response) {
                    $returnFormInclude.html(response);
                    inputfields.init();
                    validator.init();
                    onsitereturns.init();
                    uniform();
                    fillReturnInformationsForm();
                    $('html body').scrollTop(0);
                    $(window).scrollTop(0);
                    progress.hide($this);
                });
            }

            return false;
        });

        $('.orderStatSubmit').attr('disabled', 'disabled');

        $('#returnForm .input-text, #dwfrm_ordertrack .input-text').on('blur', e => {
            e.preventDefault();
            $(e.currentTarget).valid();
            const $form = $(e.currentTarget.form);
            const emptyFields = $form.find('.input-text.required:not(.filled-out)').length;
            const isEnabled = emptyFields === 0 && $form.valid();
            $form.find('.orderStatSubmit').prop('disabled', !isEnabled);
        });

        onReturnCalendarJS();
    }
};

exports.init = onsitereturns.init;
